export default __webpack_public_path__ + "static/media/not-found.e00d90de.PNG";